import { __assign, __extends } from "tslib";
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { ISortNodePayload } from "../../state/actions";
import "../../../style/components/reportOptionsList.scss";
import { SortableList } from './SortableList';
var ReportOptionsList = (function (_super) {
    __extends(ReportOptionsList, _super);
    function ReportOptionsList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReportOptionsList.prototype.render = function () {
        var _a = this.props, optionType = _a.optionType, onSortEnd = _a.onSortEnd, options = _a.options, selectedOptions = _a.selectedOptions;
        if (!options || options.length === 0) {
            return null;
        }
        var notSelectedOptions = getNotSelectedOptions(options, selectedOptions);
        return (React.createElement(SortableList, __assign({}, this.props, { axis: 'xy', helperClass: 'rb-report-option-grabbed', useDragHandle: true, onSortEnd: function (_a) {
                var oldIndex = _a.oldIndex, newIndex = _a.newIndex;
                return onSortEnd({ oldIndex: oldIndex, newIndex: newIndex, optionType: optionType });
            }, showButton: getShowButton(selectedOptions, notSelectedOptions) })));
    };
    return ReportOptionsList;
}(React.PureComponent));
export { ReportOptionsList };
var getNotSelectedOptions = function (options, selectedOptions) {
    return options.filter(function (option) { return !selectedOptions.map(function (o) { return o.value; }).includes(option.name); });
};
var getShowButton = function (selectedOptions, notSelectedOptions) {
    return notSelectedOptions &&
        notSelectedOptions.length > 0 &&
        (selectedOptions && selectedOptions.length > 0 ? !isEmpty(selectedOptions[selectedOptions.length - 1]) : true);
};
